import axios from 'axios'
import { message } from 'antd'
const baseURL = process.env.NODE_ENV === 'production' ? 'https://lcg.ccb.com' : 'https://lcg.murongtech.com'
const instance = axios.create({
	baseURL: process.env.NODE_ENV === 'production' ? 'https://lcg.ccb.com':'/',
	timeout: 30000,
})
// 添加请求拦截器
instance.interceptors.request.use(
	confing => {
		return confing
	},
	error => {
		return Promise.reject(error)
	}
)
// 添加响应拦截器
instance.interceptors.response.use(
	response =>{
		if(response.statusText ==='OK'){
			return Promise.resolve(response.data)
		}else{
			return Promise.reject(response.data.msg)
		}
	},error =>{
		if(error.response){
			return Promise.reject(error)
		}else{
			return Promise.reject('请求超时')
		}
	}
)

function NetData(method,url, params) {
	return new Promise((resove, reject = () => { }) => {
	 	return  instance({
			url,
			method,
			responseType: 'blob',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded;charset=GBK',
			},
			data: params,
		})
			.then(res => {
				var reader = new FileReader()
				reader.readAsText(res,'GBK')
				reader.onload = function(e){
					resove(reader.result)
				}	
			})
			.catch(error => {
				reject(error)
			})
	})
}

export default {
	get: (url, params = {}) => NetData('GET', url,params),
	post: (url, params = {}) => NetData('POST', url,params),
	baseURL
}